import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import { registerPwa } from "./pwa/register";
registerPwa();

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// The pre-rendered HTML is for SEO/first-paint only. It's rendered from a
// different tree (entry-server: MemoryRouter + bare page, no StrictMode/App),
// so hydrateRoot can never adopt it — React appends a duplicate page instead.
// Clear the shell and client-render.
root.innerHTML = "";
createRoot(root).render(app);
